import ReportTrashRepository from "@/repositories/vns/ReportTrashRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'reportTrash',
    namespaced: true,
    state: {
        ...makeState(),
        reportTrashsByVns: []
    },    
    getters: {
        ...makeGetters(),
        allByVns (state) {
            return state.reportTrashsByVns
        }
    },
    mutations: {
        ...makeMutations(),
        setAllByVns (state, array) {
            state.reportTrashsByVns = array
        },
    },
    actions: {
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await ReportTrashRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.vnsReportTrashs)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async listByVns ({ commit }, id) {
            commit('setLoading', true)
            await ReportTrashRepository.fetchByVns(id).then(response => {
                commit('setAllByVns', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
